
import { LngLatLike, Map, Marker, MarkerOptions, PointLike } from 'mapbox-gl';
import Vue from 'vue';
import { Component, Inject, Prop, Provide } from 'vue-property-decorator';
import { TypePOI } from '../../backend/backendapi';

@Component({
  name: 'RtMarker',
})
export default class RtMarker extends Vue {
  private initial: boolean = true;
  private marker: Marker = new Marker();
  @Inject('withMap')
  withMap!: any;
  @Prop()
  private offset?: PointLike;
  @Prop({ required: true })
  private coordinates!: LngLatLike;
  @Prop({ required: true })
  private poiId!: string;
  @Prop({ required: true })
  private type!: TypePOI;
  @Prop()
  private color?: string;
  @Prop()
  private anchor?: string;
  @Prop()
  private draggable?: boolean;

  @Provide('withMarker')
  withMarker = this.withMarkerFn.bind(this);

  public mounted() {
    // init options
    let options = { ...this.$props };
    this.addMarkerToMap(options);
    const element = this.marker.getElement();
    if (element) {
      element.addEventListener('click', () => this.clicked());
    }
    // end initial
    this.initial = false;
    this.added();
  }

  public beforeDestroy() {
    this.remove();
  }

  public addMarkerToMap(options: MarkerOptions) {
    // handle customed marker
    if (this.$slots.marker) {
      console.log('customed marker');
      console.log(this.$slots);
      console.log(this.$slots.marker[0].elm);
      options.element = this.$slots.marker[0].elm as HTMLElement;
    }
    this.marker = new Marker(options).setLngLat(this.coordinates);
    // append marker to map
    this.withMap((map: Map) => {
      this.marker.addTo(map);
    });
    // TODO handle marker popup
    // if (this.$slots.popup) {
    //     let popupDom = this.$slots.popup[0].elm as Node;
    //     let popup = new Popup().setDOMContent(popupDom);
    // }
  }

  private clicked() {
    this.$emit('clicked', { marker: this.marker, poiId: this.poiId });
  }

  private remove() {
    this.marker.remove();
    this.$emit('removed');
  }

  private added(): void {
    this.$emit('added', { marker: this.marker });
  }

  public withMarkerFn(found: (marker: Marker) => void) {
    if (this.marker) {
      found(this.marker);
    } else {
      // waiting for map load
      setTimeout(() => this.withMarkerFn(found), 50);
    }
  }
}
